
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/aschehoug/aschehoug-utdanning/vgs-app/sentry.client.config.ts")
            }
          });